import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';

import { urlEndPoints } from '../config/end-points';

@Injectable({
  providedIn: 'root',
})
export class VacationDal {
  constructor(private httpClient: HttpClient) {}

  addVacation(vacation: any): Observable<any> {
    return this.httpClient.post<any>(urlEndPoints.vacations, vacation);
  }

  getAllVacations() {
    return this.httpClient.get<any>(urlEndPoints.vacations);
  }

  getOpenVacations() {
    return this.httpClient.get<any>(urlEndPoints.vacations + '?state=OPENED');
  }

  getOpenVacationsFromTo(
    startDate?: string,
    endDate?: string,
    position?: string,
    residency?: string,
    seniority?: string,
    page?: number,
    sortField?: string,
    sortDirection?: number
  ) {
    const query =
      '&fromDate=' +
      startDate +
      '&toDate=' +
      endDate +
      (page ? '&page=' + page : '') +
      (sortField ? '&sortField=' + sortField : '') +
      (sortDirection ? '&sortDirection=' + sortDirection : '');
    return this.httpClient.get<any>(
      urlEndPoints.vacations +
        'fromTo?state=OPENED' +
        (position ? '&position=' + position : '') +
        (residency ? '&residency=' + residency : '') +
        (seniority ? '&seniority=' + seniority : '') +
        query
    );
  }

  getClosedVacations() {
    return this.httpClient.get<any>(urlEndPoints.vacations + '?state=CLOSED');
  }

  getClosedVacationsFromTo(
    startDate?: string,
    endDate?: string,
    position?: string,
    residency?: string,
    seniority?: string,
    page?: number,
    sortField?: string,
    sortDirection?: number
  ) {
    const query =
      '&fromDate=' +
      startDate +
      '&toDate=' +
      endDate +
      (page ? '&page=' + page : '') +
      (sortField ? '&sortField=' + sortField : '') +
      (sortDirection ? '&sortDirection=' + sortDirection : '');
    return this.httpClient.get<any>(
      urlEndPoints.vacations +
        'fromTo?state=CLOSED' +
        (position ? '&position=' + position : '') +
        (residency ? '&residency=' + residency : '') +
        (seniority ? '&seniority=' + seniority : '') +
        query
    );
  }

  updateVacation(vacation: any) {
    return this.httpClient.put<any>(urlEndPoints.vacations + vacation._id, vacation);
  }

  updateVolunteers(vacation: any) {
    return this.httpClient.put<any>(urlEndPoints.vacations + `${vacation._id}/voluntaries`, vacation);
  }

  getVacationRequestHistory(profileId: string, showOnHold: boolean = false, startDate?: string, endDate?: string) {
    return this.httpClient.get<any>(
      `${urlEndPoints.vacations}profile/${profileId}/${!showOnHold}?fromDate=${startDate}&toDate=${endDate}`
    );
  }

  deleteVacation(vacationID: string) {
    return this.httpClient.delete<any>(urlEndPoints.vacations + vacationID);
  }
}
